import * as React from "react";

function Cross() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <defs>
     
        </defs>
        <g transform="translate(-526 -190)">
          <g  fill="none" style={{fill:"none"}} stroke="#000" transform="translate(526 190)">
            <circle className="c" stroke="none" style={{fill:"none"}} cx="8" cy="8" r="8"/>
            <circle className="d" fill="none" style={{fill:"none"}} cx="8" cy="8" r="7.5"/>
            </g>
            <g transform="translate(0.5 0.5)">
              <line className="b" fill="none" stroke="#000" strokeLinecap="round" x2="6" y2="6" transform="translate(530.5 194.5)"/>
              <line className="b" fill="none" stroke="#000" strokeLinecap="round" x1="6" y2="6" transform="translate(530.5 194.5)"/>
              </g>
              </g>
              </svg>
  );
}

export default Cross;